import { pgTable, uuid, text, jsonb, timestamp, index } from "drizzle-orm/pg-core";
import { orders } from "./orders.js";
import { customers } from "./customers.js";

export const orderCommunications = pgTable(
  "order_communications",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    orderId: uuid("order_id").references(() => orders.id, { onDelete: "set null" }),
    customerId: uuid("customer_id").references(() => customers.id, {
      onDelete: "set null",
    }),
    channel: text("channel")
      .notNull()
      .default("email")
      .$type<"email" | "sms">(),
    messageType: text("message_type").notNull().default("transactional"),
    subject: text("subject"),
    recipient: text("recipient").notNull(),
    provider: text("provider"),
    providerMessageId: text("provider_message_id"),
    template: text("template").notNull().default("unknown"),
    locale: text("locale").default("lv"),
    status: text("status")
      .notNull()
      .default("queued")
      .$type<
        | "queued"
        | "sent"
        | "delivered"
        | "opened"
        | "clicked"
        | "bounced"
        | "failed"
        | "unsubscribed"
        | "spam"
      >(),
    statusUpdatedAt: timestamp("status_updated_at", { withTimezone: true }).defaultNow(),
    metadata: jsonb("metadata").default({}),
    templateData: jsonb("template_data").default({}),
    lastError: text("last_error"),
    storefrontSource: text("storefront_source").default("lv"),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true }).defaultNow(),
  },
  (t) => ({
    recipientIdx: index("order_communications_recipient_idx").on(
      t.recipient,
      t.createdAt,
    ),
    createdIdx: index("order_communications_created_idx").on(t.createdAt),
  }),
);

export type OrderCommunication = typeof orderCommunications.$inferSelect;
export type NewOrderCommunication = typeof orderCommunications.$inferInsert;

export const COMMUNICATION_STATUSES = [
  "queued",
  "sent",
  "delivered",
  "opened",
  "clicked",
  "bounced",
  "failed",
  "unsubscribed",
  "spam",
] as const;
export type CommunicationStatus = (typeof COMMUNICATION_STATUSES)[number];
